import { MatterDocsWithCasesFilters } from '../../../../../../../../backend/src/case/doc/dto/doc-with-cases.response.dto';
import { DateRangeFilter } from '@/new/components/date-range-filter';
import { FilterPopoverContent } from '@/new/components/filter-popover-content';
import { Label } from '@/new/components/shadcn/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/new/components/shadcn/select';

interface ServerSideFilterPopoverProps {
  filters: MatterDocsWithCasesFilters;
  onFiltersChange: (filters: MatterDocsWithCasesFilters) => void;
  clearAllFilters: () => void;
}

export function ServerSideFilterPopover({ filters, onFiltersChange, clearAllFilters }: ServerSideFilterPopoverProps) {
  const uploadStartDate = filters.startDate ? new Date(filters.startDate) : null;
  const uploadEndDate = filters.endDate ? new Date(filters.endDate) : null;
  const processedValue = filters.processed === true ? 'true' : filters.processed === false ? 'false' : undefined;

  const setUploadStartDate = (date: Date | null) => {
    onFiltersChange({
      ...filters,
      startDate: date ? date.toISOString() : undefined,
    });
  };

  const setUploadEndDate = (date: Date | null) => {
    onFiltersChange({
      ...filters,
      endDate: date ? date.toISOString() : undefined,
    });
  };

  const handleProcessingStatusChange = (value: string) => {
    if (value === 'all') {
      // Remove the processed filter
      const { processed, ...rest } = filters;
      onFiltersChange(rest);
    } else {
      onFiltersChange({
        ...filters,
        processed: value === 'true' ? true : value === 'false' ? false : undefined,
      });
    }
  };

  return (
    <FilterPopoverContent clearAllFilters={clearAllFilters}>
      <div>
        <Label className="mb-2 block">Processing Status</Label>
        <Select value={processedValue} onValueChange={handleProcessingStatusChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select processing status..." />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="true">Processed</SelectItem>
            <SelectItem value="false">Not Processed</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="mb-2 block">Upload Date Range</Label>
        <DateRangeFilter
          startDate={uploadStartDate}
          endDate={uploadEndDate}
          setStartDate={setUploadStartDate}
          setEndDate={setUploadEndDate}
        />
      </div>
    </FilterPopoverContent>
  );
}
